import styled from "styled-components";
import { colors, fonts, sizing } from "./variables.js";

const Button = styled.button`
   background: ${props => (props.inverse ? colors.bg : colors.fg)};
   color: ${props => (props.inverse ? colors.fg : colors.bg)};
   border: 3px solid ${colors.fg};
   border-radius: 0 ${sizing.borderRadius3} ${sizing.borderRadius3};
   padding: 0.3rem 1.6rem;
   text-decoration: none;

   font-family: ${fonts.default};
   font-size: 1rem;

   box-shadow: 0 4px 16px rgba(0, 0, 0, 0.3);
   outline: none;
   transition: border 0.15s ease-in-out, background 0.15s ease-in-out,
      color 0.1s ease-in-out;

   &:hover {
      cursor: pointer;
      background: ${colors.accent2};
      color: ${colors.bg};
      border-color: ${colors.accent2};
   }

   @media (max-width: 1366px) {
      border-width: 2px;
   }

   @media (max-width: 500px) {
      border-width: 1px;
   }
`;

export const IconButton = styled(Button)`
   padding: 0.35rem 0.6rem;
   font-size: 1.4rem;
   display: flex;
   border-radius: ${sizing.borderRadius3};
`;

export default Button;
